import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CmsConfig, I18nModule, provideConfig, UrlModule } from '@spartacus/core'
import { MaterialModule } from '../../shared/material.module'
import { SharedModule } from '../../shared/shared.module'
import { CustomPlaceOrderComponent } from './custom-place-order.component'
import { defaultPlaceOrderSpinnerLayoutConfig } from './default-place-order-spinner-layout.config'

@NgModule({
  declarations: [CustomPlaceOrderComponent],
  imports: [CommonModule, RouterModule, UrlModule, I18nModule, ReactiveFormsModule, MaterialModule, SharedModule],
  providers: [
    provideConfig(defaultPlaceOrderSpinnerLayoutConfig),
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutPlaceOrder: {
          component: CustomPlaceOrderComponent
        }
      }
    })
  ],
  exports: [CustomPlaceOrderComponent]
})
export class CustomPlaceOrderModule {}
